import { useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import { markStartupMetric } from '../../lib/startup-metrics';
import { BrandLoader } from './BrandLoader';
import { SpinnerGlyph } from './SpinnerGlyph';

type StartupShellProps = {
  detail?: string | null;
  detailDelayMs?: number;
};

export function StartupShell({
  detail: _detail,
  detailDelayMs: _detailDelayMs = 850,
}: StartupShellProps) {
  const { theme } = useTheme();

  useEffect(() => {
    markStartupMetric('first_shell_paint_ms');
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: theme.background }]}>
      <View accessibilityRole="progressbar" style={styles.content}>
        {/* Web gets the branded mark: on `app.tabbio.com` this shell is the
            whole page for as long as auth and fonts take, so a bare 20px
            spinner reads as a broken tab. Native keeps the small spinner —
            there the shell is behind a native splash and barely shows. */}
        {Platform.OS === 'web' ? (
          <BrandLoader size={64} />
        ) : (
          <SpinnerGlyph color={theme.textSecondary} size={20} />
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 20,
  },
});
